import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Radio, Typography, Button, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useTeachingOrder from 'state/hooks/use-teaching-order';
import EditTeachingOrderNameButton from './EditTeachingOrderNameButton';
import { TypeName } from 'state/providers/EditTeachingOrderProvider/types';

const t = (key, options?) => translate('teachingOrder', key, options);

const EditTeachingOrderSelector: React.FC = () => {
  const classes = useStyles();
  const [
    { activeTeachingOrderIndex, serializedTeachingOrders, ...state },
    { handleSetActiveTeachingOrder },
  ] = useTeachingOrder();

  return (
    <Box className={classes.boxContainer}>
      <Box marginLeft="12px">
        <Box className={classes.nameContainer}>
          <Typography className={classes.title} variant="h1">
            {state[activeTeachingOrderIndex].name}
          </Typography>
          {state[activeTeachingOrderIndex].__typename === TypeName.CUSTOM_TEACHING_ORDER && (
            <EditTeachingOrderNameButton />
          )}
        </Box>
        <Typography className={classes.subtitle} variant="body1">
          {t('titleDescription')}
        </Typography>
      </Box>
      <Box display="flex">
        {serializedTeachingOrders?.map((x, idx) => (
          <Button
            className={classes.selectorButton}
            key={`radio_selector_${idx}`}
            onClick={() => handleSetActiveTeachingOrder(+idx)}
            disableRipple
          >
            <Radio
              checked={idx === activeTeachingOrderIndex}
              onChange={() => handleSetActiveTeachingOrder(+idx)}
              value={x.id}
              name={x.name}
              inputProps={{
                'aria-label': `${x.name} radio button`,
                type: 'hidden',
              }}
            />
            <Typography variant="subtitle1" color="black">
              {x.name}
            </Typography>
          </Button>
        ))}
      </Box>
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  title: {
    fontSize: '32px',
    fontWeight: 400,
  },
  subtitle: { fontSize: '18px', fontWeight: 400, marginBottom: 10 },
  boxContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    marginTop: 32,
    marginBottom: 20,
  },
  selectorButton: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '32px',
    color: 'black',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'unset !important',
    },
    '&:active': {
      textDecoration: 'none',
      backgroundColor: 'unset !important',
    },
    '&:focus': {
      '& >span >span': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'center',
  },
}));

export default EditTeachingOrderSelector;
